export default "__VITE_ASSET__c72172ba__"